import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../helpers/request';
import moment from 'moment';
import { getQueryKeys } from '../../lib/getQueryKeys';
import useGetParamsForRequest from '../../hooks/useGetParamsForRequest';

const onArrival = async (id) => {
  const body = moment().toISOString();

  return await request.post(
    `/Access/transport/${id}/arrival`,
    body,
    'При изменение состояния пропуска произошла ошибка',
    'Error'
  );
};

const useArrival = () => {
  const queryClient = useQueryClient();

  const paramsRequestPermits = useGetParamsForRequest();

  return useMutation(onArrival, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      queryClient.refetchQueries(getQueryKeys.permits(paramsRequestPermits));
    },
  });
};

export default useArrival;
